<template>
  <div></div>
</template>

<script>
import OT from '@opentok/client';

export default {
  name: 'OpenTokSubscriber',
  props: {
    stream: {
      type: OT.Stream,
      required: true,
    },
    session: {
      type: OT.Session,
      required: true,
    },
    opts: {
      type: Object,
      required: false,
    },
    logoUrl: {
      type: String,
      default: null,
    },
  },
  mounted: function () {
    const subscriber = this.session.subscribe(
      this.stream,
      this.$el,
      this.opts,
      err => {
        if (err) {
          this.$emit('error', err);
        } else {
          this.$emit('subscriberConnected', subscriber);
          if (subscriber.stream.hasVideo) {
            const imgData = subscriber.getImgData();
            subscriber.setStyle('backgroundImageURI', imgData);
          } else {
            if (this.logoUrl) {
              subscriber.setStyle('backgroundImageURI', this.logoUrl);
            }
          }
        }
      }
    );
    this.$emit('subscriberCreated', subscriber);
    subscriber.on('videoElementCreated', event => {
      this.$emit('videoElementCreated', event.element);
    });
  },
};
</script>
